import React from 'react'
import Cell from './cell'

function MainCellEntry(props) {
  const {
    rolename,
    personIdval,
    setLocalMode,
    localMode,
    setpersonIdval,
    setRolename,
    columns,
    path,
    mode,
    data,
    pathValue,
    handleChange,
    rowIndex,
  } = props
  //
  return (
    <td
      key={path}
      className='tdclassName'
      style={{
        padding: '10px',
        border: '1px solid rgb(224, 224, 224)',
      }}
    >
      {console.log(data[path], path, 'path=====')}
      <div>
        <Cell
          // movieAndWebSeries={props.movieAndWebSeries}
          dataValues={data}
          rolename={rolename}
          personIdval={personIdval}
          setLocalMode={setLocalMode}
          localMode={localMode}
          setpersonIdval={setpersonIdval}
          setRolename={setRolename}
          columns={columns}
          path={path}
          mode={mode}
          pathValue={pathValue}
          value={data[path]}
          onChange={value => handleChange(value, rowIndex)}
        />
      </div>
    </td>
  )
}

export default MainCellEntry
